import { z } from 'zod';

/**
 * Health-check response. Used by the web app to prove the cross-app
 * contract chain is wired correctly. Replace or extend as real contracts
 * land per their owning bounded context (ADR 0004).
 */
export const HealthCheckSchema = z.object({
  status: z.enum(['OK', 'DEGRADED', 'DOWN']),
  checkedAt: z.string().datetime(),
  version: z.string().min(1),
});

export type HealthCheck = z.infer<typeof HealthCheckSchema>;
